import React from 'react'
import { Card, CardContent, Typography, Box, useTheme } from '@mui/material'
import useCustomStyles from '../../hooks/CustomStylesHook'
import { PieChart } from '@mui/x-charts'
import Colors from '../../utils/colors.json'

const styles = (theme: any) => ({
  card: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',
    padding: 2,
  },
  chartContainer: {
    position: 'relative',
    height: 180,
    marginTop: 20,
  },
  legend: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: 10,
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
  },
  legendColor: {
    width: 10,
    height: 10,
    borderRadius: '50%',
  },
})

const CustomerCard: React.FC = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  const data = {
    labels: ['Male', 'Female', 'Kids'],
    datasets: [
      {
        data: [80, 70, 60],
        backgroundColor: ['#FFC90A', '#FFE998', '#1DBF73'],
        hoverBackgroundColor: ['#FFC90A', '#FFE998', '#1DBF73'],
        borderWidth: 2,
      },
    ],
  }

  // const options = {
  //   plugins: {
  //     legend: { display: false },
  //   },
  //   cutout: '75%',
  // }

  return (
    <Card className={classes?.card} elevation={0}>
      <CardContent>
        <Typography
          variant='h6'
          fontWeight='bold'
          gutterBottom
          color={Colors.TEXT_COLOR_MAIN}
        >
          Total Customers
        </Typography>
        <Box className={classes?.chartContainer}>
          <PieChart
            margin={{ right: 5 }}
            slotProps={{
              legend: {
                hidden: true,
              },
            }}
            series={[
              {
                data: [
                  { id: 0, value: 10, label: 'series A', color: '#FFC90A' },
                  { id: 1, value: 15, label: 'series B', color: '#FFE998' },
                  { id: 2, value: 20, label: 'series C', color: '#1DBF73' },
                ],
                innerRadius: 70,
              },
            ]}
            // width={}
            height={180}
          />
        </Box>
        <Box className={classes?.legend}>
          {data.labels.map((label, index) => (
            <Box key={label} className={classes?.legendItem}>
              <span
                className={classes?.legendColor}
                style={{
                  backgroundColor: data.datasets[0].backgroundColor[index],
                }}
              ></span>
              <Typography variant='body2'>{`${label} ${data.datasets[0].data[index]}`}</Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  )
}

export default CustomerCard
